"use strict";

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.textEmphasisVariant = textEmphasisVariant;
exports["default"] = exports.defaultProps = void 0;

var _color = _interopRequireDefault(require("@bootstrap-styled/color"));

var _hover = require("./hover");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var defaultProps = {
  '$enable-hover-media-query': false
};
/**
 * @public
 * @description Forces text color and hovering from a parent component.
 * @param {boolean} enableHoverMediaQuery
 * @param {string} parent
 * @param {string} textColor
 * @returns {string}
 */

exports.defaultProps = defaultProps;

function textEmphasisVariant() {
  var enableHoverMediaQuery = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultProps['$enable-hover-media-query'];
  var parent = arguments.length > 1 ? arguments[1] : undefined;
  var textColor = arguments.length > 2 ? arguments[2] : undefined;
  return "\n  ".concat(parent, " {\n    color: ").concat(textColor, " !important;\n  }\n  a").concat(parent, " {\n  ").concat((0, _hover.hoverFocus)(enableHoverMediaQuery, "color: ".concat((0, _color["default"])(textColor).darken(0.20).rgb(), " !important;")), "\n  }\n");
}

var _default = {
  defaultProps: defaultProps,
  textEmphasisVariant: textEmphasisVariant
};
exports["default"] = _default;